<template>
    <div v-loading="loading" class="m_container">
        <form-create ref="zuopinSetting" v-model="fApi" :rule="zuopinRule" :option="option" @category-id-change="onChangeCategory" />
        <form-create v-if="zuopinCRule.length" v-model="fApi2" :rule="zuopinCRule" :option="option" />
        <ElButton v-loading="saveLoading" :disabled="isActivityEnd" type="primary" class="submitbtn" @click="submitZuopin">
            {{ $t('tougao.submit') }}
        </ElButton>
    </div>
</template>

<script>
import mixin_formCreate from '@/utils/project/formCreate_mixin'
import { getTreeChildren } from '@/utils/project/common'
import { mapGetters } from 'vuex'
import { zuopinInfo } from '@/api/Tougaos'

export default {
    name: 'ZuopinInfo',
    components: {},
    mixins: [mixin_formCreate],
    props: {
        tid: {
            type: String,
            default: ''
        },
        rule: {
            type: Array,
            default() {
                return []
            }
        },
        zpid: {
            type: Number,
            default: 0
        },
        froms: {
            type: String,
            default: ''
        },
        saveLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            language: this.$store.getters.language,
            loading: false,
            ajaxData: {
                id: undefined,
                tid: this.tid,
                info: {}
            },
            fApi: {},
            fApi2: {},
            zuopinRule: [],
            zuopinCRule: [],
            option: {
                form: {
                    inline: true,
                    labelPosition: 'right',
                    labelWidth: '100'
                },
                submitBtn: {
                    icon: 'none',
                    show: false
                }
            }
        }
    },

    computed: {
        ...mapGetters(['categoryList', 'categoryListEn', 'tougaoInfo']),
        categoryList_() {
            return this.language === 'en' ? this.categoryListEn : this.categoryList
        },
        isActivityEnd() {
            return new Date() > new Date(this.tougaoInfo.end_at)
        }
    },

    created() {
        this.getBrowser()
        if (this.froms === '/my') {
            this.getZuopinInfo(this.zpid)
        } else {
            const category_id_index = this.rule.findIndex((item) => item.field === 'category_id')
            if (category_id_index !== -1) {
                const category_id = this.rule[category_id_index].value
                if (!category_id) return
                this.onChangeCategory(category_id)
            }
            this.zuopinRule = this.resetFormRules(this.rule, {}, this.categoryList_)
        }
    },

    methods: {
        getBrowser() {
            var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf('iPhone OS') > -1 // 判断是否Opera浏览器
            isOpera ? (this.labelWidth = '82px') : ''
        },

        onChangeCategory(val) {
            const nodes = getTreeChildren(this.categoryList_, val[val.length - 1])
            if (!nodes) {
                this.zuopinCRule = []
                return
            }
            this.zuopinCRule = this.resetFormRules(nodes.setting, this.ajaxData.info, this.categoryList_)
        },

        getZuopinInfo(id) {
            this.loading = true
            zuopinInfo({ id }).then((res) => {
                this.loading = false
                if (res.code === 200) {
                    const data = res.data.data
                    this.ajaxData = data
                    this.zuopinRule = this.resetFormRules(this.rule, data.info, this.categoryList_)
                    if (data.info.category_id) this.onChangeCategory(data.info.category_id)
                }
            })
        },

        handleValidateForm() {
            console.log('this.fApi', this.ajaxData.info, this.fApi)
            let bool = true

            if (!Object.keys(this.fApi).length) return false

            if (Object.keys(this.fApi).length > 0) {
                this.fApi.validate((res) => {
                    bool = res
                    if (!res) {
                        this.$message({
                            message: this.$t('Notification.requiredFields'),
                            type: 'warning',
                            showClose: true,
                            duration: 2000
                        })
                        this.saveLoading = false
                        return false
                    }
                    this.fApi.submit((formData) => {
                        console.log('formData', formData)
                        // form-create 提交回调
                        Object.assign(this.ajaxData.info, formData)
                    })
                })
            }

            if (!bool) return false

            if (Object.keys(this.fApi2).length > 0) {
                this.fApi2.validate((res) => {
                    bool = res
                    if (!res) {
                        this.$message({
                            message: this.$t('Notification.requiredFields'),
                            type: 'warning',
                            showClose: true,
                            duration: 2000
                        })
                        this.saveLoading = false
                        return false
                    }
                    this.fApi2.submit((formData) => {
                        // form-create 提交回调
                        Object.assign(this.ajaxData.info, formData)
                    })
                })
            }

            const { info } = this.ajaxData
            console.log('info', info)
            Object.keys(info).some((key) => {
                if ((key === 'thumb_ids' || key.includes('CustomUpload')) && info[key][0]) {
                    if (Array.isArray(info[key]) && info[key].length < info[key][0].limitMin) {
                        // const customUploadIndex = key.split('_')[1]
                        // const message = key === 'thumb_ids' ? this.$t('Notification.profile_photo') : `第${customUploadIndex}个上传文件`

                        let idx = -1
                        idx = this.zuopinRule.findIndex((item) => item.field === key)
                        let title = ''
                        if (idx !== -1) {
                            title = this.zuopinRule[idx].title
                        } else {
                            idx = this.zuopinCRule.findIndex((item) => item.field === key)
                            title = this.zuopinCRule[idx].title
                        }
                        const message = key === 'thumb_ids' ? this.$t('Notification.profile_photo') : `【${title}】上传文件`
                        const mes = this.$t('Notification.min_file')
                        this.$message({
                            message: `${message}${mes}${info[key][0].limitMin}`,
                            type: 'warning',
                            showClose: true,
                            duration: 3000
                        })
                        bool = false
                        return true
                    }
                }
            })
            return bool
        },

        submitZuopin() {
            if (this.isActivityEnd || !this.handleValidateForm()) return
            this.$emit('submit', this.ajaxData)
        }
    }
}
</script>

<style lang="less" scoped>
.m_container {
    padding-top: 20px;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f5f5f5;

    .m_section {
        flex: 1;
        background: #fff;

        .el-form {
            margin-top: 10px;
            margin-right: 20px;
        }

        .form-create {
            margin-top: 0;
        }
    }

    .submitbtn {
        width: 90%;
        margin: 20px auto 0;
    }
}
.category_wrap /deep/.el-radio__input {
    display: none;
}
.category_wrap /deep/.el-radio__label {
    padding-left: 0;
}
.category_wrap /deep/.el-radio {
    margin-right: 10px;
    margin-bottom: 10px;
}
.category_wrap /deep/.el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
}
.category_wrap /deep/.el-radio.is-bordered {
    padding: 12px 10px 0 10px;
}
</style>
